import { Report1911 } from "../../../components/borrowSystem/Report/Report1911";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1911Container() {
  const titleName =
    " สรุปผลการอนุมัติให้กู้ยืมเงิน และการชำระเงินคืนเงินคืนกองทุนพัฒนาฝีมือแรงงาน จำแนกตามรายชื่อสถานประกอบกิจการ";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1911 />
      <Footer />
    </div>
  );
}
